module.exports = __webpack_public_path__ + "aprile-1.jpg?52b8b6fc63134146c36f59729b73496e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aprile-1.jpg
// module id = 146
// module chunks = 0